import moment from 'moment';
import 'bootstrap-sass';
import 'eonasdan-bootstrap-datetimepicker';
import i18n from './datetimepicker_i18n.json';

export default class Datetimepicker {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    // Get language of page
    this.lang = this._getLang();
    // console.log(this.lang);

    // Assign Font Awesome icons
    this.faIcons = {
      time: 'fa fa-clock-o',
      date: 'fa fa-calendar',
      up: 'fa fa-chevron-up',
      down: 'fa fa-chevron-down',
      previous: 'fa fa-chevron-left',
      next: 'fa fa-chevron-right',
      today: 'fa fa-bullseye',
      clear: 'fa fa-trash',
      close: 'fa fa-times'
    };

    // Set min and max date
    if (window.location.href.match('refaid')) {
      this.minDate = moment().subtract(12, 'years');
      this.maxDate = moment().subtract(1, 'years');
    } else {
      this.minDate = moment().subtract(96, 'years');
      this.maxDate = moment().subtract(45, 'years');
    }

    // Get language settings
    this.i18n = i18n.languages[0][this.lang];

    this._datetimepicker();
    this._clear();
  }

  _datetimepicker() {
    $(this.el)
      .datetimepicker({
        icons: this.faIcons,
        format: this.i18n.format,
        locale: this.i18n.locale,
        minDate: this.minDate,
        maxDate: this.maxDate,
        viewMode: 'years',
        tooltips: {
          today: this.i18n.today,
          clear: this.i18n.clear,
          close: this.i18n.close,
          selectMonth: this.i18n.selectMonth,
          prevMonth: this.i18n.prevMonth,
          nextMonth: this.i18n.nextMonth,
          selectYear: this.i18n.selectYear,
          prevYear: this.i18n.prevYear,
          nextYear: this.i18n.nextYear,
          selectDecade: this.i18n.selectDecade,
          prevDecade: this.i18n.prevDecade,
          nextDecade: this.i18n.nextDecade,
          prevCentury: this.i18n.prevCentury,
          nextCentury: this.i18n.nextCentury
        },
        widgetPositioning: {
          vertical: 'bottom'
        }
      })
      .on('dp.change', e => {
        if (e.date !== false) {
          this._change();
        }
      });
  }

  _clear() {
    $(this.el)
      .data('DateTimePicker')
      .clear();
  }

  _change() {
    if (!window.location.href.match('refaid')) {
      const $form = $(this.el).parents('form');
      $form.formValidation('revalidateField', $(this.el).attr('name'));
    }
  }

  _getLang() {
    const $html = $(this.el).parents('html');
    const langAttr = $html[0].getAttribute('lang');
    const lang = langAttr.split('-', 1);

    return lang[0];
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/datetimepicker.js